enum Saga {
  DynamoAdapterWriteError = "PBSAGDynamoAdapterWriteError",
  DynamoAdapterReadError = "PBSAGDynamoAdapterReadError",
  RestAdapterRequestException = "PBSAGRestAdapterRequestException",
  RestAdapterInvalidEndpoint = "PBSAGRestAdapterInvalidEndpoint",
  RestAdapterNoEndpointSet = "PBSAGRestAdapterNoEndpointSet",
  SagaLogInvalidEntry = "PBSAGSagaLogInvalidEntry",
  SagaLogInvalidState = "PBSAGSagaLogInvalidState",
  RedemptionFlowInvalidSagaStatus = "PBSAGRedemptionFlowInvalidSagaStatus",
  SagaNotFound = "PBSAGSagaNotFound",
  SagaNotFoundForPayment = "PBSAGSagaNotFoundForPayment",
  SagaForbiddenNotOwner = "PBSAGSagaForbiddenNotOwner",
  TokenMissing = "PBSAGTokenMissing",
  PaymentNotRequired = "PBSAGPaymentNotRequired",
  PaymentCannotCompleteSagaAborted = "PBSAGPaymentCannotCompleteSagaAborted",
  Payment3DSInputRequired = "PBSAGPayment3DSInputRequired",
  StockIssue = "PBSAGStockIssue",
  InvalidJsonRequest = "PBSAGInvalidJsonRequest",
  InvalidRequesMissingOrUnexpectedFields = "PBSAGInvalidRequesMissingOrUnexpectedFields",
  InvalidRequestEmail = "PBSAGInvalidRequestEmail",
  StepCannotStartSagaAborted = "PBSAGStepCannotStartSagaAborted",
  StepNotRequired = "PBSAGStepNotRequired",
  StepPreviousStepNotCompleted = "PBSAGStepPreviousStepNotCompleted",
  StepStepAlreadyCompleted = "PBSAGStepStepAlreadyCompleted",
  PaymentAlreadyStarted = "PBSAGPaymentAlreadyStarted",
  PaymentSuspectedAsRefused = "PBSAGPaymentSuspectedAsRefused",
  CreatePaymentFailed = "PBCTACreatePaymentFailed",
  PBSAGNotEnoughTT = "PBSAGNotEnoughTT",

  PBSAGLegacyRLOTFallbackLimit = "PBSAGLegacyRLOTFallbackLimit",
  PBSAGLegacyRLOTFallbackOpenValue = "PBSAGLegacyRLOTFallbackOpenValue",
  PBSAGLegacyRLOTFallbackEventWindow = "PBSAGLegacyRLOTFallbackEventWindow",
  PBSAGLegacyRLOTFallbackTotalPrice = "PBSAGLegacyRLOTFallbackTotalPrice"
}
export default Saga
